// extracted by mini-css-extract-plugin
export default {"container":"MoreInfo_container__3ofeC","flexDiv":"MoreInfo_flexDiv__QQ-fN","shareEmailBtn":"MoreInfo_shareEmailBtn__Y3tLI","emailSvg":"MoreInfo_emailSvg__Q1OY9"};